<template>
    <div :ref="category.id" :id="'category-' + category.id" class="scroll-mt-48 px-4">

        <h2 class="hidden md:block mt-12 text-2xl font-bold"> {{ category.name }}</h2>

        <div class="md:grid gap-8 gap-y-12" :class="category.name == 'Boots' ? 'grid-cols-2' : 'grid-cols-4'">
            <article :id="product.name" v-for="(product, idx) in products">
                <div class="grid grid-cols-1 gap-4">
                    <div>
                        <!-- Image -->
                        <img :src="rotateImage(product)" class="h-96 w-full object-cover rounded-md">

                        <!-- variants options -->
                        <div class="flex gap-1 mt-4">
                            <button @mouseover="changeVariant(idx, variant)" type="button"
                                v-for="variant in product.variants"
                                class="size-5 bg-gray-100 p-1 border border-black rounded-full btn"
                                :style="'background-color:' + variant.code">
                            </button>
                        </div>

                        <div class="flex items-end mt-4">
                            <h3 class="text-xl italic"> {{ isMobile ? category.name : product.name }}</h3>
                        </div>
                        <!-- Description -->
                        <div class="text-sm font-light mt-2 h-8">{{ product.description }}</div>
                        <!-- sizes options -->
                        <div class="flex gap-1 items-center mt-2">
                            <div class="bg-gray-200 px-2 py-1 text-xs uppercase rounded-sm"
                                v-for="sizes in product.sizes">{{ sizes }}
                            </div>
                        </div>

                        <!-- price -->
                        <p class="mt-4 text-green-600" v-if="!product.price">
                            Request a quote
                        </p>
                        <p class="mt-4 text-green-600" v-if="product.price">
                            {{ product.price }}
                        </p>

                        <button @click="addToCart(product)" class="btn btn-secondary mt-2 w-full mb-4">
                            <div v-if="loading == product.id">
                                <!-- loading spinner -->
                                <svg class="mx-auto size-6 animate-spin text-wm-blue" xmlns="http://www.w3.org/2000/svg"
                                    fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                        stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                    </path>
                                </svg>
                            </div>
                            <div v-else>
                                Add to Cart
                            </div>
                        </button>
                    </div>
                </div>
            </article>
        </div>
    </div>
</template>

<script>

import { cart } from "../cart.ts"
export default {
    props: {
        category: {
            type: Object,
            required: true,
        },
        global: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            isMobile: true,
            loading: 0,
            products: [],
        }
    },
    beforeMount() {
        this.isMobile = window.innerWidth < 768
        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 768
        })

        this.category.products.forEach((prod) => {
            this.products.push(prod)
        })

        for (var i = 0; i < this.products.length; i++) {
            let variants = this.products[i].variants;
            this.products[i].currentVariant = Object.values(variants)[0];

        }
        this.products.push({})
        this.products.pop()
    },

    mounted() {
        this.products.forEach((product) => {
            if (Array.isArray(product.currentVariant?.image)) {
                product.imageIndex = 0
                setInterval(() => {
                    product.imageIndex = (product.imageIndex + 1) % product.currentVariant.image.length;
                }, 2000);
            }
        });
    },

    methods: {
        addToCart(product) {
            this.loading = product.id;
            setTimeout(() => {
                cart.add(product, 1, product.currentVariant.color)
                this.loading = false;
            }, 300)
        },
        changeVariant(idx, variant) {
            this.products[idx].currentVariant = variant;
            this.products.push({})
            this.products.pop()
        },
        rotateImage(product) {
            if (Array.isArray(product.currentVariant.image)) {
                return product.currentVariant.image[product.imageIndex];
            } else {
                return product.currentVariant.image;
            }
        }
    },

};  
</script>
